import Api from "../../../../https/Api";

export interface IPopup {
    _id: string;
    alt: string;
    title: string;
    image: any;
    imageMobile: any;
    description: string;
    state: string;
}

export type tIPopup = Omit<IPopup, "_id" | "state">;

export class PopupService {
    private api: Api;
    constructor() {
        this.api = new Api();
    }

    async create(popup: tIPopup) {
        return this.api.post("popups/create", popup);
    }

    async uploadFile(id: any, property: any) {
        return this.api.postFile(`popups/uploadFile`, id, property);
    }

    async getImage(id: any) {
        return this.api.get(`popups/get/${id}`);
    }

    async getAllImage() {
        return this.api.get(`popups`);
    }

    async deleteImage(id: any) {
        return this.api.delete(`popups/delete/${id}`);
    }

    async deleteAllImage(ids: string[]) {
        const paramsId = {
            ids: ids,
        };
        return this.api.deleteMany(`popups/deleteMany`, paramsId);
    }

    async update(id: any, popup: any) {
        return this.api.put(`popups/update/${id}`, popup);
    }

    async choiceSecond(data: any) {
        return this.api.post("popupConfigurations/addOrUpdateConfiguration", data);
    }

    async getSeconde() {
        return this.api.get(`popupConfigurations/getConfigurations`);
    }
}
